import React from "react";
import Section from "../components/Section";
import { EDUCATION_DETAILS } from "./constants";

export default function Education() {
  return (
    <Section id="education" title="Education">
      {EDUCATION_DETAILS.map((education, index) => (
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5" key={index}>
          <div className="flex-grow-1">
            <h3 className="mb-0">{education.institution}</h3>
            <div className="subheading mb-3">{education.degree}</div>
            <div>{education.subjects}</div>
            <p>{education.cgpa}</p>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">{education.duration}</span>
          </div>
        </div>
      ))}
    </Section>
  );
}
